import type { CurrentUserRankingResponse, UserRankingPeriod, UserRankingResponse } from "../../types/api.generated";

export type RankingPeriod = UserRankingPeriod;

export interface RankingQueryParams {
  page?: number;
  limit?: number;
  period?: RankingPeriod;
}

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("tokenUser");
  return { "Content-Type": "application/json", Authorization: `Bearer ${token}` };
};

const getJsonHeaders = () => ({ "Content-Type": "application/json" });

const getBaseUrl = () => (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

const buildRankingUrl = (path: string, params: RankingQueryParams = {}) => {
  const base = getBaseUrl();
  const url = new URL(`${base}${path}`, window.location.origin);

  if (params.page) url.searchParams.set("page", String(params.page));
  if (params.limit) url.searchParams.set("limit", String(params.limit));
  if (params.period) url.searchParams.set("period", params.period);

  return base ? `${base}${path}${url.search}` : `${path}${url.search}`;
};

export const getUserRankings = async (params: RankingQueryParams = {}): Promise<UserRankingResponse> => {
  const response = await fetch(buildRankingUrl("/rankings/users", params), {
    method: "GET",
    headers: getJsonHeaders(),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Failed to load user rankings: ${response.status} ${response.statusText} ${text}`);
  }

  return response.json();
};

export const getMyUserRanking = async (params: Pick<RankingQueryParams, "period"> = {}): Promise<CurrentUserRankingResponse | null> => {
  const response = await fetch(buildRankingUrl("/rankings/users/me", params), {
    method: "GET",
    headers: getAuthHeaders(),
  });

  if (response.status === 404) {
    return null;
  }

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Failed to load my user ranking: ${response.status} ${response.statusText} ${text}`);
  }

  return response.json();
};

export const getApiRanking = () => ({ getUserRankings, getMyUserRanking });

export default getApiRanking;
